import { ToastService } from "@shared/lib/services";
import { ACCOUNT_STATUS, BackednResponse, GetAdmins } from "@shared/lib/types";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { ADMIN_LIST_QUERY_KEY } from "../constants/";
import { AdminService } from "../servcies/admin.service";

export function useGetAdmins(
  limit: number,
  pageNo: number,
  role?: string[],
  searchQuery?: string,
  accountStatus?: ACCOUNT_STATUS[],
  permissions?: string[],
  permissionGroupIds?: string[],
  pricingWorkloadEnrichments?: boolean,
  enabled?: boolean
) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<GetAdmins>
  >({
    queryKey: [
      ...ADMIN_LIST_QUERY_KEY,
      searchQuery,
      accountStatus,
      role,
      limit,
      pageNo,
      permissions,
      permissionGroupIds,
      pricingWorkloadEnrichments,
    ],
    queryFn: () =>
      AdminService.getAdmins(
        limit,
        pageNo,
        searchQuery,
        accountStatus,
        role,
        permissions,
        permissionGroupIds,
        pricingWorkloadEnrichments
      ),
    refetchInterval: pricingWorkloadEnrichments ? 2000 : undefined,
    enabled: enabled,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    admins: data?.data,
    isError,
    isFetching: isLoading,
  };
}
